module.exports = __webpack_public_path__ + "img/Profile.bce1fe4b.svg";